import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";

const SvgComponent = (props: SvgProps) => (
  <Svg width={235} height={149} fill="none" viewBox="0 0 235 149" {...props}>
    <Path
      opacity={0.2}
      d="M0 22C0 9.85 9.85 0 22 0h191c12.15 0 22 9.85 22 22v89c0 12.15-9.85 22-22 22H22c-12.15 0-22-9.85-22-22V22Z"
      fill="#ECDDBF"
    />
    <Path d="m180.882 26.614 29.805 16.045-29.805 9.678V26.614Z" fill="#003067" />
    <Path
      d="M180.882 105.081a1.298 1.298 0 0 1-1.299-1.299V26.615a1.297 1.297 0 0 1 1.299-1.3 1.302 1.302 0 0 1 1.299 1.3v77.167a1.3 1.3 0 0 1-1.299 1.299Z"
      fill="#1D60AD"
    />
    <Path
      d="M186.008 117.281a3.854 3.854 0 0 0-7.081-2.106 3.853 3.853 0 0 0 1.022 5.261c-3.01 8.979-9.159 15.705-18.644 15.412-13.034-.389-23.936-14.965-19.912-33.574 3.939-18.213 3.323-30.835-1.83-37.515-5.266-6.825-16.558-7.427-22.132-1.82-7.282 7.327-6.124 23.687-5.609 34.029.856 17.691-4.591 45.091-23.109 48.064-15.246 2.45-30.44-2.261-33.892-16.652a3.857 3.857 0 0 0 1.838-4.606 3.855 3.855 0 0 0-6.544-1.343 3.852 3.852 0 0 0 2.128 6.331c3.677 16.017 20.287 21.497 36.882 18.835 21.78-3.495 26.068-34.727 25.292-50.754-.467-9.367-1.666-25.506 4.858-32.07 4.458-4.487 13.907-4.031 18.229 1.573 4.665 6.046 5.118 17.95 1.349 35.379-4.509 20.848 8.216 36.297 22.374 36.72 13.357.399 19.103-11.237 21.189-17.325a3.853 3.853 0 0 0 3.592-3.839Z"
      fill="#6AA6EB"
    />
    <Path d="M22.354 31.392h14.902v14.9H22.354v-14.9Z" fill="#ECDDBF" />
    <Path d="M120.366 35.938h-73.75a1.3 1.3 0 1 1 0-2.598h73.75a1.3 1.3 0 1 1 0 2.598Z" fill="#C6AA6E" />
    <Path d="M22.354 62.845h14.902v14.9H22.354v-14.9Z" fill="#ECDDBF" />
    <Path d="M92.854 67.391H46.618a1.3 1.3 0 1 1 0-2.598h46.236a1.3 1.3 0 1 1 0 2.598Z" fill="#C6AA6E" />
    <Path d="M22.354 94.298h14.902v14.899H22.354V94.298Z" fill="#ECDDBF" />
    <Path d="M92.854 98.845H46.618a1.3 1.3 0 1 1 0-2.598h46.236a1.3 1.3 0 1 1 0 2.598Z" fill="#C6AA6E" />
    <Path
      d="M26.117 42.657 19.75 34a2.68 2.68 0 1 1 4.318-3.176l4.28 5.82L39.67 22.223a2.68 2.68 0 0 1 4.216 3.31l-13.501 17.19a2.681 2.681 0 0 1-4.268-.067ZM27.136 74.238l-6.368-8.659a2.681 2.681 0 1 1 4.318-3.176l4.28 5.82 11.323-14.418a2.68 2.68 0 0 1 4.216 3.31l-13.502 17.19a2.681 2.681 0 0 1-4.267-.067Z"
      fill="#6AA6EB"
    />
  </Svg>
);

export default SvgComponent;
